import {
    type DocumentData,
    type FirestoreDataConverter,
    type QueryDocumentSnapshot,
    type SnapshotOptions,
} from 'firebase/firestore'
import type { UserRole } from '~/types/user'

export const userRolesConverter: FirestoreDataConverter<UserRole> = {
    fromFirestore: (
        snapshot: QueryDocumentSnapshot<UserRole>,
        options: SnapshotOptions,
    ): UserRole => {
        const data = snapshot.data(options)

        return { id: snapshot.id, ...data } as UserRole // Adjust this mapping as necessary
    },
    toFirestore: (modelObject: UserRole): DocumentData => {
        const { id, ...userRole } = modelObject
        return { ...userRole }
    },
}
